import React, { useContext } from "react";
import FormDataContext from "./formContext";
import { stepThree } from "./step3Data";
import MainStepper from "./MainStepper";
import { useForm } from "react-hook-form";

function FormStep3() {
  let { inputsUiRendering, data, step, setStep } = useContext(FormDataContext);
  let {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: data,
  });

  return (
    <form onSubmit={handleSubmit(() => setStep(step + 1))}>
      <div className="stepsIndication">Step {step} of 6</div>

      <h1 className="stepTitle">Choose your Interests</h1>
      {inputsUiRendering(stepThree, register, control, errors, setValue)}
      <MainStepper handleSubmit={handleSubmit} isValid={isValid} />
    </form>
  );
}

export default FormStep3;
